import { useMemo, useState } from 'react';

import { getColumnOptions } from '@/lib/utils/tables';
import { SessionHub } from '@addmile/backend-client';
import { AccessorKeyColumnDef } from '@tanstack/react-table';

export const useColumnsVisibility = ({
  columnsKeys,
  columns,
}: {
  columnsKeys: Record<string, boolean>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: any;
}) => {
  const [columnVisibility, setColumnVisibility] = useState(columnsKeys);

  const toggleColumnVisibility = (columnId: string) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };

  const columnOptions = useMemo(() => {
    return getColumnOptions(
      columns as unknown as AccessorKeyColumnDef<SessionHub>[],
      columnVisibility,
    );
  }, [columns, columnVisibility]);

  return { columnVisibility, toggleColumnVisibility, columnOptions };
};
